import { render, staticRenderFns } from "./highlights.vue?vue&type=template&id=5cca7860&scoped=true"
import script from "./highlights.vue?vue&type=script&lang=js"
export * from "./highlights.vue?vue&type=script&lang=js"
import style0 from "./highlights.vue?vue&type=style&index=0&id=5cca7860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cca7860",
  null
  
)

export default component.exports